<template>
  <div style="margin-bottom: 24px">
    <el-row :gutter="24" type="flex;">
      <el-col :span="6">
        <div class="statistic-total card" v-loading="statisticLoading">
          <div class="data">
            <div class="data-total">
              <div class="data-total-label">{{ $t('Device.deviceNum') }}</div>
              <div class="data-total-count num-font">{{ data.totalNum | format }}</div>
            </div>
            <div class="data-category">
              <div class="data-category-item online">
                <div class="label">{{ $t('Device.bound') }} ({{ bindPercent | format }})</div>
                <div class="count">{{ data.bound | format }}</div>
              </div>
              <div class="data-category-item offline">
                <div class="label">{{ $t('Device.unbind') }} ({{ unbindPercent | format }})</div>
                <div class="count">{{ data.unbound | format }}</div>
              </div>
            </div>
          </div>
          <div class="progress">
            <div class="progress-label">{{ $t('Device.bindStatus') }}</div>
            <el-progress
              :stroke-width="8"
              :percentage="getPercent(data.bound, data.totalNum)"
              :show-text="false"
            ></el-progress>
            <div style="display: flex;justify-content: space-between;padding-top: 6px">
              <div style="color:#2046C7">{{ $t('Device.bound') }}</div>
              <div style="color:#999999">{{ $t('Device.unbind') }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="statistic-status card " v-loading="statisticLoading">
          <div class="status-item card todayInstall">
            <div class="status-item-num">
              <div class="count num-font">{{ data.todayInstall || '0' }}</div>
              <div class="label">{{ $t('Device.todayInstall') }}</div>
            </div>
          </div>
          <div class="status-item card fault">
            <template v-if="data.fault > 0">
              <div class="count num-font">{{ data.fault | format }}</div>
              <div class="label">{{ $t('Device.deviceFault') }}</div>
            </template>
            <template v-else>
              <div class="is-empty">
                <svg class="icon empty-ring" aria-hidden="true">
                  <use xlink:href="#icon-smile"></use>
                </svg>
                <div class="empty-label">{{ $t('Device.tips2') }}</div>
              </div>
            </template>
          </div>
          <div class="status-item card normal">
            <div class="status-item-num">
              <div class="count num-font">{{ data.normal | format }}</div>
              <div class="label">{{ $t('Device.normalDevice') }}</div>
            </div>
            <el-progress
              type="circle"
              :percentage="normalPercent"
              :width="100"
              :stroke-width="10"
              :color="cyanblueColor"
            ></el-progress>
          </div>
        </div>
      </el-col>
    </el-row>

    <!--
  <div class="statistic" v-if="data.totalNum > 0">
    <div class="statistic-left">
      <div class="statistic-total card" v-loading="statisticLoading">
        <div class="data">
          <div class="data-total">
            <div class="data-total-label">{{ $t('Device.deviceNum') }}</div>
            <div class="data-total-count num-font">{{ data.totalNum | format }}</div>
          </div>
          <div class="data-category">
            <div class="data-category-item online">
              <div class="label">{{ $t('Device.bound') }} ({{ bindPercent }})</div>
              <div class="count">{{ data.bound | format }}</div>
            </div>
            <div class="data-category-item offline">
              <div class="label">{{ $t('Device.unbind') }} ({{ unbindPercent }})</div>
              <div class="count">{{ data.unbound | format }}</div>
            </div>
          </div>
        </div>
        <div class="progress">
          <div class="progress-label">{{ $t('Device.bindStatus') }}</div>
          <el-progress
            :stroke-width="8"
            :percentage="getPercent(data.bound, data.totalNum)"
            :show-text="false"
          ></el-progress>
          <div style="display: flex;justify-content: space-between;padding-top: 6px">
            <div style="color:#2046C7">{{ $t('Device.bound') }}</div>
            <div style="color:#999999">{{ $t('Device.unbind') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="statistic-right">
      <div class="statistic-status card " v-loading="statisticLoading">
        <div class="status-item card todayInstall">
          <div class="status-item-num">
            <div class="count num-font">{{ data.todayInstall || '0' }}</div>
            <div class="label">{{ $t('Device.todayInstall') }}</div>
          </div>
        </div>
        <div class="status-item card fault">
          <template v-if="data.fault > 0">
            <div class="count num-font">{{ data.fault | format }}</div>
            <div class="label">{{ $t('Device.deviceFault') }}</div>
          </template>
          <template v-else>
            <div class="is-empty">
              <svg class="icon empty-ring" aria-hidden="true">
                <use xlink:href="#icon-smile"></use>
              </svg>
              <div class="empty-label">{{ $t('Device.tips2') }}</div>
            </div>
          </template>
        </div>
        <div class="status-item card normal">
          <div class="status-item-num">
            <div class="count num-font">{{ data.normal | format }}</div>
            <div class="label">{{ $t('Device.normalDevice') }}</div>
          </div>
          <el-progress
            type="circle"
            :percentage="normalPercent"
            :width="100"
            :stroke-width="10"
            :color="cyanblueColor"
          ></el-progress>
        </div>
      </div>
    </div>
  </div>-->
  </div>
</template>

<script>
import { format } from '@/utils/utils'
import { cyanblueColor } from '@/style/var.scss'
export default {
  props: {
    productId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: {},
      cyanblueColor,
      statisticLoading: false
    }
  },
  // created() {
  //
  // },
  mounted() {
    this.getStatisticsData()
  },
  watch: {
    productId() {
      this.getStatisticsData()
    }
  },
  computed: {
    // 已绑定设备百分比
    bindPercent() {
      const percent = this.getPercent(this.data.bound, this.data.totalNum)
      return percent ? percent.toFixed(2) + '%' : 0 + '%'
    },
    // 未绑定设备百分比
    unbindPercent() {
      const percent = this.getPercent(this.data.unbound, this.data.totalNum)
      return percent ? percent.toFixed(2) + '%' : 0 + '%'
    },
    // 正常设备百分比
    normalPercent() {
      const percent = this.getPercent(this.data.normal, this.data.totalNum)
      return parseFloat(percent ? percent.toFixed(2) : 0)
    }
  },
  filters: {
    format
  },
  methods: {
    getStatisticsData() {
      this.statisticLoading = true
      const params = {
        productKey: this.productId
      }
      this.$ajax
        .get(this.$api.iceDevice.iceDevice_statistics, params)
        .then((res) => {
          if (res.data) {
            this.data = res.data
          }
        })
        .catch(() => {})
        .finally(() => {
          this.statisticLoading = false
        })
    },
    getPercent(data, total) {
      if (isNaN(data) || isNaN(total)) {
        return 0
      }
      const num = (data / total) * 100
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
$--offline-color: #c1c6cc;
.card {
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px -2px 20px 0px rgba(34, 42, 57, 0.05);
  border-radius: 16px;
}
.statistic {
  //width: 100%;
  //display: flex;
  //margin-bottom: 24px;
}
.statistic-left {
  flex-basis: 30%;
  flex-shrink: 0;
  margin-right: 24px;
  height: 238px;
}
.statistic-total {
  padding: 24px;
  height: 100%;
  .data {
    display: flex;
    justify-content: space-between;
  }
  .data-total-label {
    font-size: 16px;
    color: #666666;
  }
  .data-total-count {
    font-size: 48px;
    color: #333333;
    font-weight: 600;
  }
  .data-category-item {
    margin-bottom: 24px;
    .label {
      position: relative;
      color: #666666;
      &::before {
        content: '';
        position: absolute;
        left: -14px;
        top: 3px;
        width: 10px;
        height: 10px;
        border-radius: 2px;
      }
    }
    .count {
      margin-top: 6px;
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
    &.online .label::before {
      background-color: $--color-blue;
    }
    &.offline .label::before {
      background-color: $--offline-color;
    }
  }
  .progress {
    /deep/ {
      .el-progress-bar__inner {
        background-color: $--color-blue;
      }
      .el-progress-bar__outer {
        background-color: $--offline-color;
      }
    }
  }
  .progress-label {
    color: #666666;
    margin-bottom: 10px;
  }
}
.statistic-right {
  //flex: 1;
  height: 238px;
}

.statistic-status {
  display: flex;
  justify-content: space-between;
  height: 238px;
  .status-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    & + .status-item {
      margin-left: 24px;
    }
  }
  .status-item-num {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .count {
    font-size: 36px;
    color: #333333;
    font-weight: 600;
  }
  .label {
    color: #666666;
  }
  .is-empty {
    text-align: center;
    position: relative;
    height: 100%;
    .empty-ring {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 90px;
      height: 90px;
    }
    .empty-label {
      position: absolute;
      left: 50%;
      top: 44%;
      transform: translate(-50%, -50%);
      width: 55px;
      text-align: center;
    }
  }
  .todayInstall {
    flex-basis: 30%;
    background: url('../../../assets/device_pic_today_install_bg.jpg') no-repeat left center / cover;
    .count {
      color: #ffffff;
    }
    .label {
      color: #ffffff;
    }
    ///deep/ {
    //  .el-progress__text {
    //    font-size: 16px;
    //    color: #ffffff;
    //    font-weight: 600;
    //  }
    //  .el-progress-circle__track {
    //    stroke: #d4eef0;
    //  }
    //}
  }
  .alarm {
    flex-basis: 30%;
    background: url('../../../assets/warning_bg.jpg') no-repeat left center / cover;
    .empty-ring {
      color: #d8c29b;
    }
  }
  .fault {
    flex-basis: 20%;
    background: url('../../../assets/fault_bg.jpg') no-repeat left center / cover;
    .count {
      color: #ffffff;
    }
    .label {
      color: #ffffff;
    }
    .empty-ring {
      color: #e79b9b;
    }
    .empty-label {
      color: #ffffff;
      line-height: 16px;
    }
  }
  .normal {
    flex-direction: row;
    align-items: center;
    flex-basis: 50%;
    background: url('../../../assets/normal_bg.jpg') no-repeat left center / cover;

    /deep/ {
      .el-progress__text {
        font-size: 16px;
        color: #333333;
        font-weight: 600;
      }
      .el-progress-circle__track {
        stroke: #d4eef0;
      }
    }
  }
}
</style>
